import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Course } from '../../apis/api-client';

interface CourseState {
  courses: Course[];
}

const initialState: CourseState = {
  courses: [],
};

export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setCourses: (state, action: PayloadAction<Course[]>) => {
      state.courses = action.payload;
    },
    addCourse: (state, action: PayloadAction<Course>) => {
      state.courses.push(action.payload);
    },
    updateCourse: (state, action: PayloadAction<{ id: number; course: Course }>) => {
      const index = state.courses.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.courses[index] = { ...action.payload.course };
      }
    },
    removeCourse: (state, action: PayloadAction<number>) => {
      state.courses = state.courses.filter((c) => c.id !== action.payload);
    },
  },
});

export const { setCourses, addCourse, updateCourse, removeCourse } = courseSlice.actions;
export default courseSlice.reducer;
